<template>
    <div >
        <b-table
          small
          :fields="fields"
          :items="list_order"
          responsive
          striped hover
        >
    
          <!-- <template #cell(status)="data">
            <b-badge block :variant="data.item.status === 3 ? 'success': 'danger'"  >
                 {{data.item.status === 3 ? "Pago": "Aberto"}}
            </b-badge>
          </template> -->

            <template #cell(amount)="data">
            <b-badge block :variant=" Math.sign(data.item.amount)  === 1 ? 'success': 'danger'"  >
                 {{formatPriceR(data.item.amount)}}
            </b-badge>
          </template>

          <template #cell(cumulativeSum)="data">
            <b-badge block :variant="'info'"  >
                 {{formatPriceR(data.item.cumulativeSum)}}
            </b-badge>
          </template>
      
    
          <template #cell(valor)="data">
            {{ formatPriceR(data.item.valor) }}
          </template>
    
       
        </b-table>
    </div>
</template>
    
    <script>
    import { BTable, BProgress, BBadge,BButton,BRow, BCol,BFormInput,BInputGroup,BInputGroupPrepend } from 'bootstrap-vue'

  
    export default {
        components: {
            BTable,
            BProgress,
            BBadge,
            BButton,BRow,BCol,BFormInput,BInputGroup,BInputGroupPrepend, 
        },
        data() {
            return {
            // dynamicMask:"#####.#####",
            fields: [

                { key: 'transactionType', label: 'Operação' },
                { key: 'createdAt', label: 'Data' }, 
                { key: 'amount', label: 'Valor' }, 
                { key: 'cumulativeSum', label: 'Saldo' }, 
                { key: 'description', label: 'Descrição' },
            
            ],
        
            }
        },
        watch: {
            respostaPix (value) {
                console.log(value)
            }
    
        },
        computed:{
            list_order() {
            return this.$store.state.estabelecimentos.list_movimento
            },
        },
        methods:{
        formatPriceR(value) {
          return value.toLocaleString('pt-br', {minimumFractionDigits: 2});
      },
    
    
        }
    }
    </script>
    
    <style scoped>
         
    </style>